import { ApiResListsType, OhsApiRequestName, RequestType } from 'global-services/api/OhsApiModels';
import OhsApiRequest from 'global-services/api/OhsApiRequest';
import { ModuleType } from 'global-services/constants/OhsObject';

import { OhsIncidentLtiFilterPayload, OhsLtiTargetTier } from './OhsIncidentModels';

export const getIncidentLtiLists = (
  filterInfo: OhsIncidentLtiFilterPayload
): Promise<ApiResListsType<any[]> | null> => {
  return OhsApiRequest(
    RequestType.Module,
    ModuleType.Incident,
    OhsApiRequestName.IncidentLtiLists,
    {
      filter: filterInfo,
    }
  );
};

export const getIncidentOldestLtiLists = (
  payload: OhsLtiTargetTier
): Promise<ApiResListsType<any[]> | null> => {
  return OhsApiRequest(RequestType.Module, ModuleType.Incident, OhsApiRequestName.FetchOldest, {
    targetTier: { ...payload },
  });
};

export const setUpdateLtiHours = (payload: any): Promise<any> =>
  OhsApiRequest(
    RequestType.Module,
    ModuleType.Incident,
    OhsApiRequestName.SetIncidentLtiLists,
    payload
  );

export const OhsIncidentLtiServices = {
  getIncidentLtiLists,
  setUpdateLtiHours,
  getIncidentOldestLtiLists,
};
